import { Component, OnInit } from '@angular/core';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { Subscription } from 'rxjs';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ApiService } from '@services/api.service';
import { DataHelper } from '@helpers/data.helper';
import { DataService } from '@services/data.service';

type tabsType = {
  title: string;
  timeType: number;
};

@Component({
  selector: 'app-side-slider-top-winner',
  templateUrl: '../../sharedTemplates/side-banner-top-winner.component.html',
  animations: [
    trigger('openClose', [
      state(
        'open',
        style({
          opacity: 1,
          backgroundColor: 'var(--white-color-200)',
        })
      ),
      state(
        'closed',
        style({
          height: '0',
          opacity: 0,
          backgroundColor: 'var(--always-white)',
        })
      ),
      transition('open <=> closed', [animate('.3s')]),
    ]),
  ],
})
export class SideBannerTopWinnerComponent implements OnInit {
  tabs: tabsType[] = [
    {
      title: 'Today',
      timeType: 1,
    },
    {
      title: 'timeFilter_week',
      timeType: 2,
    },
    {
      title: 'Month',
      timeType: 3,
    },
  ];
  isMobileView: boolean;
  private subscriptionsToStopOnDestroy: Subscription[] = [];

  constructor(private _UiHelper: UiHelper, private _UserHelper: UserHelper, private _ApiService: ApiService, public _DataHelper: DataHelper, private _DataService: DataService) {
    this.isMobileView = true;
  }

  onTabClick(tabId: number): void {
    this._DataHelper.topWinnerDataActiveTab = tabId;
  }

  handleOpen(whichItem: number) {
    this._DataHelper.topWinnerData[this._DataHelper.topWinnerDataActiveTab] = this._DataHelper.topWinnerData[this._DataHelper.topWinnerDataActiveTab].map((item, index) => {
      if (item.isOpen === false) {
        item.isOpen = index === whichItem;
        return item;
      }
      if (item.isOpen === true) {
        item.isOpen = false;
        return item;
      }
    });
  }

  getTopWinnerData = (timeType: any) => {
    const data = this._DataHelper.topWinnerData[timeType];
    if (data && data?.length > 0) {
      return data;
    }
    return [];
  };
  ngOnInit(): void {
    this.isMobileView = this._UiHelper.windowsWidth < 990;
    this.subscriptionsToStopOnDestroy.push(
      this._UiHelper.windowResized.subscribe(x => {
        this.isMobileView = x.w < 990;
      })
    );
  }
}
